import React from 'react';
import { DraggableObject } from '../../../lib/canvas';
import {
	CanvasEntityDisabledReason,
	checkHasBaseEntity,
	DefinitionEntityState,
} from '@elyx-code/project-logic-tree';
import { EditorService } from '../../../services/editor';
import { BaseEntityNames } from '@elyx-code/project-logic-tree';
import DatabaseAction from './actions/persisted-entity/DatabaseFooterAction';
import RestablishConnectionFooterAction from './actions/external-integration-connection/RestablishConnectionFooterAction';
import ExportCredentialsFooterAction from './actions/external-integration-connection/ExportCredentialsFooterAction';
import GoogleDriveFilePickerAPIFooterAction from './actions/google-drive/GoogleDriveFilePickerAPIFooterAction';

interface IDynamicFooterActionsProps {
	draggableObject: DraggableObject;
	entity: DefinitionEntityState;
	project: EditorService;
	parentDisabledReasons: CanvasEntityDisabledReason[];
}

function DynamicFooterActions(props: IDynamicFooterActionsProps) {
	const generateEntityActions = () => {
		const entity = props.entity;

		const actions: JSX.Element[] = [];

		if (checkHasBaseEntity(entity, BaseEntityNames.HTTP_ENDPOINT)) {
			// TODO: add HTTP endpoint specific actions
		}

		if (checkHasBaseEntity(entity, BaseEntityNames.PERSISTED_ENTITY)) {
			actions.push(
				<DatabaseAction
					key='persisted-entity-database-action'
					entity={entity}
					project={props.project}
					draggableObject={props.draggableObject}
					parentDisabledReasons={props.parentDisabledReasons}
				/>,
			);
		}

		if (checkHasBaseEntity(entity, BaseEntityNames.CRON_JOB)) {
			// TODO: add Cron Job specific actions
		}

		if (checkHasBaseEntity(entity, BaseEntityNames.RELATIONAL_DATABASE)) {
			// TODO: add Relational Database specific actions (probably similar to the ones for Persisted Entity, but with some differences)
		}

		if (
			checkHasBaseEntity(
				entity,
				BaseEntityNames.EXTERNAL_INTEGRATION_CONNECTION,
			)
		) {
			actions.push(
				<ExportCredentialsFooterAction
					key='export-credentials-action'
					entity={entity}
					project={props.project}
					draggableObject={props.draggableObject}
					parentDisabledReasons={props.parentDisabledReasons}
				/>,
				<RestablishConnectionFooterAction
					key='restablish-connection-action'
					entity={entity}
					project={props.project}
					draggableObject={props.draggableObject}
					parentDisabledReasons={props.parentDisabledReasons}
				/>,
			);
		}

		if (
			checkHasBaseEntity(entity, BaseEntityNames.GOOGLE_DRIVE_AUTH_CONNECTION)
		) {
			actions.push(
				<GoogleDriveFilePickerAPIFooterAction
					key='google-drive-file-picker-api-footer-action'
					entity={entity}
					project={props.project}
					draggableObject={props.draggableObject}
					parentDisabledReasons={props.parentDisabledReasons}
				/>,
			);
		}

		return actions;
	};

	return (
		<div
			className={
				'canvas-draggable-card__footer' +
				(!!props.parentDisabledReasons.length ? ' disabled' : '')
			}
			style={{
				display: 'flex',
				gap: 6,
				alignItems: 'flex-end',
				justifyContent: 'flex-end',
				padding: '0px 5px',
			}}
		>
			{generateEntityActions()}
		</div>
	);
}

export default DynamicFooterActions;
